















































































import { Note } from "@/models/order/order";
import { Component, Vue, Prop, Mixins, Watch } from "vue-property-decorator";
import ShowAllNotesModal from "@/components/elements/modal/ShowAllNotesModal.vue";
import { NoteFields } from "@/models/order/helpers";
import { ProductType } from "@/models/products/product";
import Table from "../elements/utility/Table.vue";
import { Mobile } from "@/mixins/mobile";

@Component({
  components: {
    ShowAllNotesModal,
    Table,
  },
})
export default class LineItemRow extends Mixins(Mobile) {
  @Prop({ default: () => [] }) itemNotes!: Note[];
  @Prop() index!: number;
  @Prop() type!: ProductType;
  protected noteObj: {
    model: string;
    canopy: string;
    frame: string;
    valance: string;
    finial: string;
    rib: string;
    bottomPole: string;
    finish: string;
    stem: string;
    options: string;
    fabric: string;
  } | null = null;
  protected showModal = false;
  protected newItemNotes: Note[] = [];

  @Watch("itemNotes", { deep: true })
  updateNotes(): void {
    this.setUpNotes();
  }

  created(): void {
    this.setUpNotes();
  }

  protected setUpNotes(): void {
    this.noteObj = {} as any;
    switch (this.type) {
      case ProductType.Umbrella: {
        const uf = [
          "model",
          "canopy",
          "frame",
          "valance",
          "bottomPole",
          "finial",
          "rib",
        ];
        uf.forEach((field) => {
          const obj = this.itemNotes!.find((e) => e.field === field);
          if (obj) {
            this.noteObj![field] = obj.content;
          } else {
            this.noteObj![field] = "";
          }
        });
        break;
      }
      case ProductType.Base: {
        const bf = ["finish", "stem", "model", "options"];
        bf.forEach((field) => {
          const obj = this.itemNotes!.find((e) => e.field === field);
          if (obj) {
            this.noteObj![field] = obj.content;
          } else {
            this.noteObj![field] = "";
          }
        });
        break;
      }
      case ProductType.Chair: {
        const cf = ["model", "fabric"];
        cf.forEach((field) => {
          const obj = this.itemNotes!.find((e) => e.field === field);
          if (obj) {
            this.noteObj![field] = obj.content;
          } else {
            this.noteObj![field] = "";
          }
        });
        break;
      }
      case ProductType.Accessory: {
        const af = ["model"];
        af.forEach((field) => {
          const obj = this.itemNotes!.find((e) => e.field === field);
          if (obj) {
            this.noteObj![field] = obj.content;
          } else {
            this.noteObj![field] = "";
          }
        });
        break;
      }
    }
  }

  protected closeModal(): void {
    this.showModal = false;
    this.addNotesToQuote();
    this.$emit("updateNotes", this.newItemNotes, this.index);
  }

  protected addNotesToQuote(): void {
    this.newItemNotes = [];
    for (const [key, value] of Object.entries(this.noteObj!)) {
      this.newItemNotes.push({
        field: key as NoteFields,
        content: value as string,
      });
    }
  }

  protected openModal(): void {
    this.showModal = true;
  }
}
